import "#legacy/shared/sparkle_namespace.js";

if (!Sparkle.MyChart) {
  Sparkle.MyChart = {
    Events: {
      on() {
        return jQuery(Sparkle.MyChart.Events).on(...arguments);
      },
      trigger() {
        jQuery(Sparkle.MyChart.Events).trigger(...arguments);
        return jQuery(window).trigger(...arguments);
      },
    },
  };

  // The OAuth popup window will communicate `epic_oauth_patient` via postMessage after the user logs in (see EHRAppointmentsController#oauth).
  window.addEventListener("message", (event) => {
    // Read through `window`: a page whose bundle never loads the appointment booking code has no `AppointmentBooking`
    // global, and a bare reference to it throws on every message.
    const oauthUrlSetting = window.AppointmentBooking?.config?.oauth_url;
    if (!oauthUrlSetting) {
      return;
    }

    // Ensure origin is one we trust to prevent XSS (See https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage#notes)
    const oauthUrl = new URL(oauthUrlSetting);
    const oauthRedirectUri = new URL(oauthUrl.searchParams.get("redirect_uri"));
    if (event.origin !== oauthRedirectUri.origin) {
      return;
    }

    // The analytics events carry no properties of their own, so the patient never reaches the analytics log.
    // `sparkleAnalytics` is undefined only where no analytics loads.
    if (event.data.epic_oauth_patient) {
      window.sparkleAnalytics?.("track", "$mychart-login");
      return Sparkle.MyChart.Events.trigger("mychart:login", event.data.epic_oauth_patient);
    } else if (event.data.epic_oauth_error) {
      window.sparkleAnalytics?.("track", "$mychart-login-error");
      return Sparkle.MyChart.Events.trigger("mychart:loginError", event.data.epic_oauth_error);
    }
  });
}
